let routerNavigate = null

export const registerRouterNavigate = (navigate) => {
  routerNavigate = navigate
}

export const navigate = (to, options) => {
  if (routerNavigate) {
    return routerNavigate(to, options)
  }

  if (typeof window === 'undefined') return

  if (options?.replace) {
    window.location.replace(to)
  } else {
    window.location.assign(to)
  }
}
